import {devtools} from 'zustand/middleware'
import {produce} from 'immer'
import {create} from "zustand";
import {MapperServerSearchResultType} from "../libs/mapServerSearchResult";
import {FilterStateType, ProductSearchStateType} from "./types";


type Actions = {
    fetchingProducts: () => Promise<void>
    setLoading: (isLoading: boolean) => void
    setResultSearch: (result: MapperServerSearchResultType, isLoadMore?: boolean) => void
    setSearchValue: (searchTerm: string) => void
    setFilterState: (state: FilterStateType) => void
    resetSearch: () => void
}
const INITIAL_STATE:ProductSearchStateType= {
    products: null,
    suggestions: [],
    search: {
        token: "",
        suggest: "",
    },
    metaPagination: {
        count: 0,
        start_from: 0,
        limit: 20,
    },
    filter: {
        state: {},
        selectors: {},
    },
    isLoading: true,
    error: null,
}

export const useProductSearchStore = create<ProductSearchStateType & Actions>()(
    devtools(
        (set) => ({
            products: null,
            suggestions: [],
            search: {
                token: "",
                suggest: "",
            },
            metaPagination: {
                count: 0,
                start_from: 0,
                limit: 20,
            },
            filter: {
                state: {},
                selectors: {},
            },
            isLoading: true,
            error: null,

            setSearchValue: (searchValue: string) => {
                set(produce(state => {
                    state.search.token = searchValue;
                }))
            },
            setLoading: (isLoading: boolean) => {
                set(
                    produce(state => {
                        state.isLoading = isLoading;
                    })
                )
            },
            setResultSearch: (result: MapperServerSearchResultType, isLoadMore = false) => {
                set(produce(state => {
                    state.products = isLoadMore ? [...state.products, ...result.products] : result.products;
                    state.suggestions = result.suggestions;
                    state.search.suggest = `${state.search.token}${result.search.suggest}`;
                    state.metaPagination = result.metaPagination;
                    state.filter.selectors = result.filterSelectors;
                }))
            },
            setFilterState: (filter: FilterStateType) => {
                set(produce(state => {
                    state.filter.state = filter;
                }))
            },
            resetSearch: () => {
                set(produce(state => {
                    state.isLoading = true;
                    state.error = null;
                    state.products = null;
                    state.suggestions = []
                    state.search = {
                        token: "",
                        suggest: "",
                    }
                    state.metaPagination = {
                        count: 0,
                        start_from: 0,
                        limit: 20,
                    }
                    state.filter = {
                        state: {},
                        selectors: {},
                    }
                }))
            }
        })
    )
)